module.exports = __webpack_public_path__ + "static/astrolabe-b5d837cd0a5b537e8dd9713fe0fe26da.jpg";